import { render, staticRenderFns } from "./Markup.vue?vue&type=template&id=1308cbe0&"
import script from "./Markup.vue?vue&type=script&lang=js&"
export * from "./Markup.vue?vue&type=script&lang=js&"
import style0 from "./Markup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VIcon,VSlideXTransition})
